import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantUserService } from 'app/services';

@Component({
    selector: 'partner-employee-reset-password',
    templateUrl: './partner-employee-reset-password.component.html',
    styleUrls: ['./partner-employee-reset-password.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerEmployeeResetPasswordComponent {
    constructor(
        private messageService: MessageService,
        private merchantUserService: MerchantUserService) {
    }

    @Input()
    public showResetPassword: boolean = false;

    @Input()
    public merchantUser: any = {};

    @Input()
    public onHide: () => void = () => { };
    public loading: boolean = false;

    public passwordIsChanged: boolean = false;

    public resetPassword() {
        const dto = {
            MerchantUserId: this.merchantUser.UserId
        };
        this.loading = true;
        this.merchantUserService.forceResetPassword(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.passwordIsChanged = true;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleHideResetPasswordDialog() {
        this.onHide();
    }
}
